export default __webpack_public_path__ + "static/media/feature-team_tab_2.d7febaa99fbff67a6f749b398ceb6c85.svg";